module.exports = __webpack_public_path__ + "static/media/arrow_up_graph.1e4b0a16.svg";